export enum ToastActions {
    SHOW = 'SHOW' ,
    SHOWSIDEBAR = 'SHOWSIDEBAR'
}



// WEBPACK FOOTER //
// ./src/constants/toastActions.ts